import { twMerge } from "tailwind-merge";
import { Alert } from "../../../components/alert/Alert";

export const FullDutyAlert = ({
  buyerName,
  className,
}: {
  className?: string;
  buyerName: string;
}) => {
  return (
    <Alert
      className={twMerge(className)}
      message={`Make any order edits before confirming. "Draught duty relief has not been applied" will be displayed underneath the relevant line items on this order's invoice`}
      title={`${buyerName} has requested full duty paid for eligible items on this order`}
      type={"warning"}
    />
  );
};
